import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';
import axios from 'axios';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1)
  }
}));

const Profile = props => {
  const {token, className, ...rest } = props;
  const classes = useStyles();
  
  const [user, setUser] = useState({
    name: '',
    avatar: '/images/avatars/avatar_12.png',
    bio: 'ลงชื่อเข้าใช้'
  });
  
  const url = 'https://eslip.snru.ac.th/backend/api/users/me';
  useEffect(() => {
    let source = axios.CancelToken.source();    

    const loadData = async () => {
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: 'Bearer ' + token.access_token
          },
          cancelToken: source.token
        });
        console.log("AxiosCancel: got response");
        setUser({
          name: response.data.person.fnamethai,
          avatar: 'https://neport.snru.ac.th/FILES/'+response.data.person.pic,
          bio: response.data.person.role
        });

        localStorage.setItem('profile', JSON.stringify(response.data));

      } catch (error) {
        if (axios.isCancel(error)) {
          console.log("AxiosCancel: caught cancel");
        } else {
          throw error;
        }
      }
    };

    (token)?loadData():(setUser({
      name: '',
      avatar: '/images/avatars/avatar_12.png',
      bio: 'ลงชื่อเข้าใช้'
    }));

    return () => {
      console.log("AxiosCancel: unmounting");
      source.cancel();
    };
  }, [token]);

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src={user.avatar}
        to="/settings"
      />
      <Typography
        className={classes.name}
        variant="h4"
      >
        {user.name}
      </Typography>
      <Typography variant="body2">{user.bio}</Typography>
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string,
  token: PropTypes.object
};

export default Profile;
